import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import invariant from 'invariant';
import AuthRedirectContext from '../AuthProvider/AuthRedirectContext';

function RedirectToLogin(_ref) {
  var push = _ref.push;
  var ctx = useContext(AuthRedirectContext);
  invariant(ctx, "Use 'RedirectToLogin' inside 'AuthProvider'");
  var loginPath = ctx.loginPath,
      useLocation = ctx.useLocation,
      useRedirect = ctx.useRedirect;
  var setRedirect = useRedirect();
  var location = useLocation();
  useEffect(function () {
    setRedirect(loginPath, {
      from: location
    }, push);
  }, [location, loginPath, push, setRedirect]);
  return null;
}

RedirectToLogin.propTypes = {
  push: PropTypes.bool
};
RedirectToLogin.defaultProps = {
  push: false
};
export default RedirectToLogin;